import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Button, Form, Row, Col, Modal, Table, Pagination } from 'react-bootstrap';
import { faRefresh, faHandPointer, faEye, faPaperPlane, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from '../../../shared/spinner';
import RemessaCessaoService from "../../../services/remessaCessaoService";
import CessaoService from "../../../services/cessaoService";

function RemessaCessao() {
  const [loading, setLoading] = useState(false);
  const [remessas, setRemessas] = useState<any[]>([]);
  const [numCessao, setNumCessao] = useState('');
  const [nomeCessao, setNomeCessao] = useState('');
  
  const [showModal, setShowModal] = useState(false);
  const [detalhesRemessa, setDetalhesRemessa] = useState<any | null>(null);
  const [selectedProtocol, setSelectedProtocol] = useState<string | null>(null);

  const [isGenerating, setIsGenerating] = useState(false);
  const [buscandoNomeCessao, setBuscandoNomeCessao] = useState(false);
  
  // Estados para a paginação
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const remessaCessaoService = new RemessaCessaoService();
  const cessaoService = new CessaoService();

  // Função para buscar o nome da cessão pelo ID
  const buscarNomeCessao = async (id: string) => {
    if (!id) {
      setNomeCessao('');
      return;
    }

    setBuscandoNomeCessao(true);
    try {
      const response = await cessaoService.listarCessaoPorId(id);
      if (response.data && response.data.nome) {
        setNomeCessao(response.data.nome);
      } else {
        setNomeCessao('Cessão não encontrada');
      }
    } catch (error) {
      console.error('Erro ao buscar nome da cessão:', error);
      setNomeCessao('Cessão não foi encontrada');
    } finally {
      setBuscandoNomeCessao(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (numCessao) {
        buscarNomeCessao(numCessao);
      } else {
        setNomeCessao('');
      }
    }, 500); 
    return () => clearTimeout(timer);
  }, [numCessao]);

  // Função para buscar as remessas da API
  const fetchRemessas = async () => {
    setLoading(true);
    try {
      const response = await remessaCessaoService.buscarRemessasPaginadas(page, size);
      const { content, totalPages, totalElements } = response.data;
      
      setRemessas(content);
      setTotalPages(totalPages);
      setTotalElements(totalElements);
    } catch (error) {
      console.error('Erro ao buscar remessas:', error);
      setRemessas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRemessas();
  }, [page, size]);

  const handleSolicitarRemessa = async () => {
    if (!numCessao) {
      alert('Informe o Nº da cessão antes de solicitar a remessa.');
      return;
    }

    setLoading(true);
    try {
      const response = await remessaCessaoService.buscarOperacoesRemessa(Number(numCessao));
      setDetalhesRemessa(response.data);
      setShowModal(true);
    } catch (error) {
      console.error('Erro ao buscar remessas:', error);
      alert('Erro ao buscar as remessas. Verifique o console para mais detalhes.');
    } finally {
      setLoading(false);
    }
  };

  // --- NOVAS AÇÕES DA TABELA PRINCIPAL ---
  const handleVisualizarRemessaTabela = (item: any) => {
    try {
      if (item.json) {
        const parsed = JSON.parse(item.json);
        setDetalhesRemessa({ [item.protocoloCessao]: parsed.contratos || [] });
        setSelectedProtocol(item.protocoloCessao);
        setShowModal(true);
      } else {
        alert("Esta remessa não possui detalhes JSON disponíveis.");
      }
    } catch (e) {
      console.error("Erro ao converter JSON", e);
      alert("Erro ao ler os detalhes da remessa.");
    }
  };

  const handleReenviarRemessa = async (item: any) => {

    if (window.confirm(`Deseja reenviar a remessa do protocolo ${item.protocoloCessao} para a AWS S3?`)) {
      setLoading(true);
      try {
        const response = await cessaoService.enviarGabaritoS3(item.protocoloCessao);
        alert(response.data || `Remessa ${item.protocoloCessao} reenviada com sucesso!`);
        fetchRemessas(); // Atualiza a tabela para pegar novo status/data
      } catch (error: any) {
        console.error("Erro ao reenviar remessa:", error);
        alert(`Erro: ${error.response?.data || "Falha na comunicação com o servidor."}`);
      } finally {
        setLoading(false);
      }
    }
  };

  // Função para DOWNLOAD EXCEL (Gabarito)
  const handleBaixarArquivo = async (item: any) => {
     if (!numCessao) {
       alert("Por favor, digite o número da cessão no campo de busca acima antes de baixar o arquivo.");
       return;
    }

    setLoading(true);
    try {
      const response = await cessaoService.gerarGabarito(Number(numCessao));
      const payload = response.data;
      
      // A API retorna algo como: { mensagem: "...", arquivoBase64: "...", nomeArquivo: "..." }
      if (payload && payload.arquivoBase64) {
         // Converte Base64 para Blob para forçar o Download no navegador
         const byteCharacters = atob(payload.arquivoBase64);
         const byteNumbers = new Array(byteCharacters.length);
         for (let i = 0; i < byteCharacters.length; i++) {
             byteNumbers[i] = byteCharacters.charCodeAt(i);
         }
         const byteArray = new Uint8Array(byteNumbers);
         const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
         
         // Cria o link invisível e clica nele
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.setAttribute('download', payload.nomeArquivo || `GABARITO_CESSAO_${numCessao}.xlsx`);
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      } else {
         alert("O arquivo não foi retornado corretamente pelo servidor.");
      }

    } catch (error: any) {
      console.error("Erro ao gerar download:", error);
      alert(`Erro: ${error.response?.data || "Falha ao gerar o arquivo Excel."}`);
    } finally {
      setLoading(false);
    }
  };
  // ----------------------------------------

  const handleCloseModal = () => {
    setShowModal(false);
    setDetalhesRemessa(null);
    setSelectedProtocol(null);
  };

  const handleProtocolClick = (protocolo: string) => {
    setSelectedProtocol(protocolo);
  };

  const handleGerarRemessa = async () => {
    if (!selectedProtocol) {
      alert('Nenhum protocolo selecionado para gerar a remessa.');
      return;
    }

    setIsGenerating(true);
    try {
      const operacoesDoProtocolo = detalhesRemessa[selectedProtocol];
      const numerosContrato = operacoesDoProtocolo.map((op: any) => op.numeroContrato);
      
      const dadosEnvio = [numCessao, selectedProtocol, ...numerosContrato];

      await cessaoService.envioCessaoMotor(dadosEnvio);

      alert(`Remessa do protocolo ${selectedProtocol} gerada e enviada com sucesso!`);

      handleCloseModal();
      fetchRemessas();
    } catch (error) {
      console.error('Erro ao gerar a remessa:', error);
      alert('Ocorreu um erro ao gerar a remessa. Por favor, tente novamente.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleSizeChange = (newSize: number) => {
    setSize(newSize);
    setPage(0);
  };

  const renderPaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(0, page - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    items.push(<Pagination.First key="first" onClick={() => handlePageChange(0)} disabled={page === 0} />);
    items.push(<Pagination.Prev key="prev" onClick={() => handlePageChange(page - 1)} disabled={page === 0} />);

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item key={i} active={i === page} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }

    items.push(<Pagination.Next key="next" onClick={() => handlePageChange(page + 1)} disabled={page >= totalPages - 1} />);
    items.push(<Pagination.Last key="last" onClick={() => handlePageChange(totalPages - 1)} disabled={page >= totalPages - 1} />);

    return items;
  };

  return (
    <div className="position-relative m-md-3">
      {/* Cabeçalho igual ao do print */}
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
        <h5>Remessa de Cessão</h5>
      </div>

      {/* Filtros (Nº Cessão, Nome Cessão, Botões) */}
      <div className="mb-3 p-2 border rounded">
        <Row className="align-items-end">
          <Form.Group as={Col} md="3">
            <Form.Label>Nº Cessão</Form.Label>
            <Form.Control
              type="text"
              value={numCessao}
              onChange={(e) => setNumCessao(e.target.value)}
              placeholder="Digite o nº da cessão"
              disabled={buscandoNomeCessao}
            />
          </Form.Group>
          <Form.Group as={Col} md="5">
            <Form.Label>Nome Cessão</Form.Label>
            <Form.Control
              type="text"
              value={nomeCessao}
              onChange={(e) => setNomeCessao(e.target.value)}
              placeholder="O nome da cessão aparecerá automaticamente"
              disabled
              className={nomeCessao ? '' : 'text-muted'}
            />
          </Form.Group>
          <Col md="4" className="d-flex justify-content-end gap-2">
            <Button 
              id="App-button-cor-principal-escura" 
              onClick={handleSolicitarRemessa}
              disabled={loading || !numCessao || !nomeCessao || nomeCessao === 'Cessão não encontrada'}
            >
              Solicitar Remessa Cessão
            </Button>
            <Button 
              variant="secondary" 
              onClick={fetchRemessas}
              disabled={loading}
            >
              <FontAwesomeIcon icon={faRefresh} />
            </Button>
          </Col>
        </Row>
      </div>

      {/* Controles de paginação - Topo */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <Form.Label className="me-2 mb-0">Itens por página:</Form.Label>
          <Form.Select 
            style={{ width: '80px' }} 
            value={size} 
            onChange={(e) => handleSizeChange(Number(e.target.value))}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Form.Select>
        </div>
        
        <div className="text-muted">
          Mostrando {remessas.length} de {totalElements} registros
        </div>
      </div>

      {/* Tabela */}
      {loading ? (
        <Spinner loading={loading} />
      ) : (
        <>
          <div className="table-responsive mt-3">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th id="App-header-table">ID</th>
                  <th id="App-header-table">Protocolo</th>
                  <th id="App-header-table">Status</th>
                  <th id="App-header-table">Data de Criação</th>
                  <th id="App-header-table">Mensagem</th>
                  <th id="App-header-table" className="text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {remessas.length > 0 ? (
                  remessas.map((item) => (
                    <tr key={item.id}>
                      <td className="align-middle">{item.id}</td>
                      <td className="align-middle">{item.protocoloCessao}</td>
                      <td className="align-middle">
                        {item.status === 'ENVIADO_S3' ? 'ENVIADO' : item.status}
                      </td>
                      <td className="align-middle">{item.dtaCriacao ? new Date(item.dtaCriacao).toLocaleString() : ''}</td>
                      <td className="align-middle" style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.mensagem}>{item.mensagem}</td>
                      <td className="text-center align-middle">
                        <Button variant="link" className="p-0 me-3 text-primary" title="Reenviar Remessa (S3)" onClick={() => handleReenviarRemessa(item)}>
                          <FontAwesomeIcon icon={faPaperPlane} />
                        </Button>
                        <Button variant="link" className="p-0 text-success" title="Download Gabarito Excel" onClick={() => handleBaixarArquivo(item)}>
                          <FontAwesomeIcon icon={faDownload} />
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">Nenhuma remessa encontrada</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Paginação - Rodapé */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination>
                {renderPaginationItems()}
              </Pagination>
            </div>
          )}

          {/* Informações da página atual */}
          <div className="text-center text-muted mt-2">
            Página {page + 1} de {totalPages}
          </div>
        </>
      )}
      
      {/* Modal para exibir os protocolos e detalhes */}
      <Modal show={showModal} onHide={handleCloseModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedProtocol ? (
              `Detalhes do Protocolo: ${selectedProtocol}`
            ) : (
              <div className="d-flex align-items-center">
                Protocolos de Cessão Encontrados
              </div>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProtocol ? (
            <div>
              <Button variant="secondary" onClick={() => setSelectedProtocol(null)} className="mb-3">
                ← Voltar para a lista de protocolos
              </Button>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>ID Operação</th>
                    <th>Nº Contrato</th>
                    <th>Valor Cedido</th>
                    <th>Dt. Inclusão</th>
                    <th>Quant. Parcelas</th>
                  </tr>
                </thead>
                <tbody>
                  {detalhesRemessa && detalhesRemessa[selectedProtocol] && detalhesRemessa[selectedProtocol].map((operacao: any, idx: number) => (
                    <tr key={operacao.id || idx}>
                      <td>{operacao.idOperacao || operacao.id}</td>
                      <td>{operacao.numeroContrato || (operacao.proposta && operacao.proposta.numeroContrato)}</td>
                      <td>{operacao.valorCedido ? Number(operacao.valorCedido).toFixed(2) : '-'}</td>
                      <td>{operacao.dtInclusao ? new Date(operacao.dtInclusao).toLocaleString() : '-'}</td>
                      <td>{operacao.quantidadeParcelasCedidas || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            detalhesRemessa && Object.keys(detalhesRemessa).length > 0 ? (
              <div>
                <Table striped bordered hover responsive className="table-clickable">
                  <thead>
                    <tr>
                      <th style={{ width: '70%' }}>
                        <div className="d-flex align-items-center">
                          Protocolo de Cessão
                          <FontAwesomeIcon icon={faHandPointer} className="ms-2 text-warning" />
                        </div>
                      </th>
                      <th style={{ width: '30%' }}>Número de Operações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(detalhesRemessa).map((protocolo) => (
                      <tr 
                        key={protocolo} 
                        onClick={() => handleProtocolClick(protocolo)} 
                        className="clickable-row"
                        style={{ 
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                          e.currentTarget.style.transform = 'scale(1.01)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '';
                          e.currentTarget.style.transform = 'scale(1)';
                        }}
                      >
                        <td>
                          <div className="d-flex align-items-center justify-content-between">
                            <strong>{protocolo}</strong>
                            <FontAwesomeIcon icon={faHandPointer} className="text-muted" />
                          </div>
                        </td>
                        <td>
                          <span className="badge bg-primary rounded-pill">
                            {detalhesRemessa[protocolo].length} operações
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <div className="text-center text-muted mt-2">
                  <small>💡 Clique em qualquer protocolo para visualizar suas operações</small>
                </div>
              </div>
            ) : (
              <div className="text-center py-4">
                <p>Nenhum protocolo de cessão encontrado.</p>
              </div>
            )
          )}
        </Modal.Body>
        <Modal.Footer>
          {selectedProtocol && (
            <Button
              id="App-button-cor-principal-escura"
              onClick={handleGerarRemessa}
              disabled={isGenerating}
            >
              {isGenerating ? 'Gerando...' : 'Gerar e Enviar Remessa'}
            </Button>
          )}
          <Button variant="secondary" onClick={handleCloseModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Estilos CSS para melhorar a aparência dos elementos clicáveis */}
      <style>
        {`
          .table-clickable .clickable-row:hover {
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }
          .clickable-row td {
            position: relative;
          }
          .clickable-row:hover td:first-child::before {
            content: "👉";
            position: absolute;
            left: -25px;
            top: 50%;
            transform: translateY(-50%);
          }
        `}
      </style>
    </div>
  );
}

export default RemessaCessao;